import { transform, isEqual, isObject, isEmpty, isArray } from "lodash";

class ObjectHelper {
  /**
   * Método realiza cópia de um objeto JSON
   * @param object
   * @returns {any}
   */
  clone(object) {
    return JSON.parse(JSON.stringify(object));
  }

  /**
   * Método realiza uma cópia de uma instância de classe
   * @param instance
   * @returns {any}
   */
  cloneClass(instance) {
    return Object.assign(
      Object.create(Object.getPrototypeOf(instance)),
      instance
    );
  }

  /**
   * Deep diff between two object, using lodash
   * @param  {Object} object Object compared
   * @param  {Object} base   Object to compare with
   * @return {Object}        Return a new object who represent the diff
   */
  difference(object, base) {
    return transform(object, (result, value, key) => {
      if (!isEqual(value, base[key])) {
        result[key] =
          isObject(value) && isObject(base[key])
            ? this.difference(value, base[key])
            : value;
      }
    });
  }

  /**
   * Método remove chaves com valor vazia de um objeto
   * @param object
   * @returns {*}
   */
  removeEmptyFields(object) {
    const newObject = this.clone(object);

    Object.keys(newObject).forEach(key => {
      if (
        newObject[key] &&
        typeof newObject[key] === "object" &&
        !isEmpty(newObject[key])
      ) {
        newObject[key] = this.removeEmptyFields(newObject[key]);
      } else if (
        newObject[key] === undefined ||
        newObject[key] === null ||
        newObject[key] === ""
      ) {
        delete newObject[key];
      } else {
        newObject[key] = newObject[key];
      }
    });

    return newObject;
  }

  /**
   * Método remove chaves com valor vazia de um objeto
   * @param object
   * @returns {*}
   */
  removeEmptyFieldsEmpty(object) {
    const newObject = this.clone(object);

    Object.keys(newObject).forEach(key => {
      if (
        newObject[key] &&
        typeof newObject[key] === "object" &&
        !isEmpty(newObject[key])
      ) {
        newObject[key] = this.removeEmptyFields(newObject[key]);
      } else if (
        newObject[key] === undefined ||
        newObject[key] === null ||
        newObject[key] === "" ||
        (isArray(newObject[key]) && newObject[key].length == 0) ||
        (typeof newObject[key] === "object" &&
          Object.keys(newObject[key]).length == 0)
      ) {
        delete newObject[key];
      } else {
        newObject[key] = newObject[key];
      }
    });

    return newObject;
  }

  existInArray(array, valueEqual, objectKey = null) {
    let key = null;
    array.forEach((value, keyArray) => {
      if (objectKey != null) {
        value = value[objectKey];
      }
      if (valueEqual === value) {
        key = keyArray;
        return;
      }
    });
    return key;
  }
}

export default new ObjectHelper();
